const API_KEY = 'BRANDFOLDER_API_KEY';
const WELCOME = 'BRANDFOLDER_WELCOME';

export const removeApiKey = () => {
  return window.localStorage.removeItem(API_KEY);
};

export const getApiKey = () => {
  return window.localStorage.getItem(API_KEY);
};

export const hasApiKey = () => {
  return getApiKey() !== null && getApiKey().trim().length > 0;
};

export const setApiKey = apiKey => {
  window.localStorage.setItem(API_KEY, apiKey);
};

export const hasWelcome = () => {
  return window.localStorage.getItem(WELCOME) !== null;
};

export const setWelcome = () => {
  window.localStorage.setItem(WELCOME, 1);
};



// WEBPACK FOOTER //
// ./src/services/localStorage.js